module.exports = __webpack_public_path__ + "img/b-games.31535582.png";